module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._v(" "), _c('vuetable', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    attrs: {
      "showEdit": true,
      "showDelete": true,
      "tableData": _vm.tableData,
      "tableTitle": 'Point To Ports',
      "fields": [{
          header: 'Origin Point',
          prop: function (item) { return item.originPoint ? item.originPoint.name : ''; }
        },
        {
          header: 'Destination Point',
          prop: function (item) { return item.destinationPoint ? item.destinationPoint.name : ''; }
        }
      ],
      "maxItems": _vm.maxValue
    },
    on: {
      "table-delete-request": _vm.deleteEntity,
      "table-edit-request": _vm.handleEdit,
      "pages-remaining": _vm.loadMore
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90dfec6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/PointToPort/PointToPortSearchResults.vue
// module id = 2253
// module chunks = 1